// extracted by mini-css-extract-plugin
export var card = "styles-module--card--ibb7v";
export var servicesCard = "styles-module--servicesCard--ImPuZ";
export var servicesFigure = "styles-module--servicesFigure--kv9mz";